import React, { useState } from "react";
import aboutimg from "../image/productbanner4.jpg";
import axios from "axios";
import BaseUrl from './Baseurl/Api.js';


const ContactForm = () => {
  const name_validate = (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, "");
  };

  // Mobile number validation function
  const mobile_valid = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "");
  };

  const [formData, setFormData] = useState({
    fname: "",
    mail: "",
    phone: "",
    msg: "",
  });
  const [showModal, setShowModal] = useState(false); // modal state

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const res = await BaseUrl.post(
      "/api/Save-contact-enq",
      formData
    );

    if (res.data.status) {
      setShowModal(true); // show modal
      setFormData({ fname: "", mail: "", phone: "", msg: "" }); // reset form

      // Auto-close modal after 3 seconds
      setTimeout(() => {
        setShowModal(false);
      }, 1000);
    }
  } catch (error) {
    console.error(error);
    alert("Something went wrong!");
  }
};

  const contactstyle = `
  html {
  scroll-behavior: smooth;
}
  .contact-intro .btn-primary {
  background: linear-gradient(45deg, #007bff, #00c6ff);
  border: none;
  transition: transform 0.3s, box-shadow 0.3s;
}

.contact-intro .btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.contact-intro p.lead {
  font-size: 1.1rem;
  line-height: 1.6;
}
  `;

  return (
    <>
    <style>{contactstyle}</style>
{/* Contact Page Intro */}
<section className="contact-intro position-relative overflow-hidden">
  <div
    className="breadcrumb-banner d-flex align-items-center justify-content-center text-center"
    style={{
      backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${aboutimg})`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      height: "400px", // limited height
    }}
  >
    <div className="container text-white">
      {/* Heading with fade-in on load */}
      <h1 className="display-5 fw-bold animate__animated animate__fadeInDown" style={{ fontFamily: "'Poppins', sans-serif" }}>
        Get in Touch with Us
      </h1>

      {/* Subtext with subtle fade-in */}
      <p className="lead mt-3 animate__animated animate__fadeInUp animate__delay-1s" style={{ fontFamily: "'Montserrat', sans-serif", maxWidth: "600px", margin: "0 auto" }}>
        Have questions or suggestions? We're here to help! Fill out the form below or reach us directly via email or phone.
      </p>

      {/* Optional Call-to-Action Button */}
      <a
        href="#contactForm"
        className="btn btn-primary btn-lg mt-4 animate__animated animate__fadeInUp animate__delay-2s"
        style={{ fontFamily: "'Poppins', sans-serif" }}
      >
        Contact Now
      </a>
    </div>
  </div>
</section>


      {/* About Section */}
      <div id="contactForm"
        style={{
          backgroundColor: "#fff",
          padding: "40px 20px",
          borderRadius: "10px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          margin: "20px",
        }}
      >
        <div className="container-fluid">
          <div className="row justify-content-center text-center">
            <div className="col-lg-10">
              <h2 style={{ color: "#4CAF50", fontSize: "32px", fontWeight: "700" }}>
                🌾 Get In Touch
              </h2>
              <p style={{ fontSize: "18px", color: "#555", lineHeight: "1.8" }}>
                Pearl Millet is a crucial cereal crop, especially in dry regions. Its
                drought resistance ensures food security and supports farmers facing
                harsh climatic conditions. This crop is a lifeline, helping combat
                poverty while thriving in arid zones.
              </p>
            </div>
          </div>
        </div>
      </div>



   <section className="py-5 contact-section" style={{ backgroundColor: "#f7fdf9" }}>
  <div className="container">
    <div className="row align-items-center justify-content-center">

      {/* Contact Info */}
      <div className="col-lg-5 col-md-12 contact-info mb-4 animate__animated animate__fadeInLeft">
        <div className="contact-card p-5 shadow-lg rounded-4" style={{ background: "#ffffff" }}>
          <h3 className="text-success fw-bold mb-3" style={{ fontFamily: "'Poppins', sans-serif", fontSize: "24px" }}>🌾 Get In Touch</h3>

          <div className="info-item mb-3 d-flex align-items-center">
            <span className="icon me-3" style={{ fontSize: "24px" }}>📍</span>
            <p className="mb-0" style={{ fontSize: "16px", color: "#555" }}>8273 NW 56th ST Miami, 33195 US</p>
          </div>

          <div className="info-item mb-3 d-flex align-items-center">
            <span className="icon me-3" style={{ fontSize: "24px" }}>📞</span>
            <p className="mb-0" style={{ fontSize: "16px", color: "#555" }}>+0511 01220 3320</p>
          </div>

          <div className="info-item mb-3 d-flex align-items-center">
            <span className="icon me-3" style={{ fontSize: "24px" }}>📧</span>
            <p className="mb-0" style={{ fontSize: "16px", color: "#555" }}>info@agrom.com</p>
          </div>

          <div className="social-icons mt-4">
            <span style={{ fontSize: "26px", marginRight: "15px", cursor: "pointer" }}>🌿</span>
            <span style={{ fontSize: "26px", marginRight: "15px", cursor: "pointer" }}>🌱</span>
            <span style={{ fontSize: "26px", marginRight: "15px", cursor: "pointer" }}>🌻</span>
            <span style={{ fontSize: "26px", marginRight: "15px", cursor: "pointer" }}>🚜</span>
          </div>
        </div>
      </div>

      {/* Contact Form */}
      <div className="col-lg-5 col-md-12 contact-form animate__animated animate__fadeInRight">
        <div className="contact-card p-5 shadow-lg rounded-4" style={{ background: "#ffffff" }}>
          <form className="form" onSubmit={handleSubmit}>
            <input type="text" className="form-control mb-4" name="fname" placeholder="Name" value={formData.fname} onChange={handleChange} required style={{ fontSize: "16px", fontFamily: "'Poppins', sans-serif" }} />
            <input type="email" className="form-control mb-4" name="mail" placeholder="Email address" value={formData.mail} onChange={handleChange} required style={{ fontSize: "16px", fontFamily: "'Poppins', sans-serif" }} />
            <input type="text" className="form-control mb-4" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required style={{ fontSize: "16px", fontFamily: "'Poppins', sans-serif" }} />
            <textarea className="form-control mb-4" name="msg" placeholder="Your message" value={formData.msg} onChange={handleChange} required style={{ fontSize: "16px", fontFamily: "'Poppins', sans-serif", height: "120px" }} />

            <button type="submit" className="btn btn-success w-100 fw-bold py-2" style={{ fontSize: "18px", fontFamily: "'Montserrat', sans-serif' " }}>SEND MESSAGE</button>
          </form>
        </div>
      </div>
    </div>
  </div>

  {/* Modal */}
  {showModal && (
  <div
    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center animate__animated animate__fadeIn"
    style={{ background: "rgba(0,0,0,0.6)", zIndex: 1050 }}
  >
    <div className="bg-white p-5 rounded-4 shadow-lg text-center animate__animated animate__zoomIn"
      style={{ maxWidth: "400px" }}
    >
      {/* Icon */}
      <i className="bi bi-check-circle-fill mb-3" style={{ fontSize: "50px", color: "#4CAF50" }}></i>

      <h3 className="mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>Thank You!</h3>
      <p className="mb-4" style={{ fontFamily: "'Poppins', sans-serif", fontSize: "16px" }}>
        Your enquiry has been submitted successfully. We’ll get back to you soon.
      </p>
    </div>
  </div>
)}


  {/* Additional CSS */}
  <style jsx>{`
    .contact-card input, 
    .contact-card textarea {
      border: 1px solid #ccc;
      border-radius: 8px;
      padding: 14px;
      transition: all 0.3s ease;
    }
    .contact-card input:focus,
    .contact-card textarea:focus {
      border-color: #4CAF50;
      box-shadow: 0 0 8px rgba(76, 175, 80, 0.4);
      outline: none;
    }
    .contact-card button:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    }
    @media (max-width: 768px) {
      .social-icons {
        justify-content: center;
        display: flex;
        margin-top: 20px;
      }
      .contact-card {
        padding: 30px 20px;
      }
    }
  `}</style>
</section>



      {/* Map Section */}
      <div className="container mt-4">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d96727.26876811644!2d-73.921359!3d40.746029!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a560db693e3%3A0xb05e8b0bdf854b54!2sGowanus%2C%20Brooklyn%2C%20Nueva%20York%2C%20EE.%20UU.!5e0!3m2!1ses-419!2sdo!4v1741699148192!5m2!1ses-419!2sdo"
          width="100%"
          height="450"
          style={{ border: 0, borderRadius: "10px" }}
          allowFullScreen
          loading="lazy"
          title="Google Map"
        ></iframe>
      </div>

      {/* CSS Styling */}
      <style jsx>{`
          
          .contact-info {
            padding: 20px;
          }
          .info-item {
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            color: #333;
          }
          .info-item .icon {
            font-size: 22px;
            margin-right: 15px;
            color: #4CAF50;
          }
          .social-icons span {
            font-size: 25px;
            margin-right: 15px;
            cursor: pointer;
          }
          .contact-form input,
          .contact-form textarea {
            width: 100%;
            padding: 12px;
            margin-bottom: 15px;
            border: 1px solid #ccc;
            border-radius: 8px;
            background-color: #fff;
          }
          .contact-form textarea {
            height: 120px;
            resize: none;
          }
          .contact-form button {
            width: 100%;
            padding: 12px;
            background-color: #4CAF50;
            color: #fff;
            border: none;
            font-weight: bold;
            border-radius: 8px;
            cursor: pointer;
          }
          .contact-form button:hover {
            background-color: #45a049;
          }
      
          /* Responsive */
          @media (max-width: 768px) {
            .contact-info, .contact-form {
              text-align: center;
            }
            .info-item {
              justify-content: center;
            }
            .social-icons {
              text-align: center;
              margin-top: 20px;
            }
          }
        `}</style>
    </>
  );
};

export default ContactForm;
